<template>
    <div>
        <DxDropDownBox
            ref="dropDownBoxRefName"
            :drop-down-options="dropDownOptions"
            :data-source="getProductionInfo"
            :value.sync="currentValue"
            display-expr="품번"
            value-expr="품번"
            content-template="contentTemplate"
            :disabled='getEdit'
            @opened = "onOpened"
        >
          <template #contentTemplate="{}">
            <dx-data-grid ref='refCoilGrid'
              :data-source='getProductionInfo'
              :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
              :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
              column-resizing-mode = 'widget' :allow-column-reordering = "true"
              :height='gridHeight'
              @selection-changed = "onSelectionChanged"
            >
              <DxSearchPanel
                :visible="true"
                placeholder="검색..."
              />
              <DxFilterRow
                :visible="true"
                apply-filter="auto"
              />
              <DxColumn
                caption="품번"
                data-field="품번"
                width = '100'>
              </DxColumn>

              <DxColumn
                caption="재질"
                data-field="재질"
                sort-order='asc'
                width = '140'>
              </DxColumn>
              <DxColumn
                :allowEditing='true'
                caption="두께"
                data-field="자사두께"
                :visible='true'
                format='#,##0.0'
                dataType="number"
                width="60"
              >
              </DxColumn>
              <DxColumn
                :allowEditing='true'
                caption="가로"
                data-field="자사가로"
                :visible='true'
                format='#,##0'
                dataType="number"
                width="60"
              >
              </DxColumn>
              <DxColumn
                :allowEditing='true'
                caption="세로"
                data-field="자사세로"
                :visible='true'
                format='#,##0'
                dataType="number"
                width="60"
              >
              </DxColumn>
              <DxColumn
                caption="상위유형"
                data-field="상위품목유형">
                <DxLookup
                  :data-source="itemTypeLookup"
                  display-expr="코드명"
                  value-expr="코드"
                />
              </DxColumn>
              <DxColumn
                caption="품명"
                data-field="품명">
              </DxColumn>
              <dx-paging :enabled="false"/>
              <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
              <dx-sorting mode="multiple"/>
            </dx-data-grid>
          </template>
        </DxDropDownBox>
    </div>
</template>

<script>
import DxDataGrid, { DxScrolling, DxFilterRow, DxLookup,
  DxColumn, DxPaging, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'
import ConstDef from '../ConstDef'
import DxDropDownBox from 'devextreme-vue/drop-down-box'

export default {
  name: 'CoilGridComponent',
  data: function () {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 630 },
      dataSource: null,
      gridHeight: 300,
      itemTypeLookup: null
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    productionInfo: {
      type: Array,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    onValueChanged: {
      type: Function,
      default: () => function (data) {
        // console.log(data)
      }
    },
    filteringKey: {
      type: String,
      default: null
    },
    filteringValue: {
      type: String,
      default: null
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    DxDropDownBox,
    DxFilterRow,
    DxLookup
  },
  computed: {
    getProductionInfo () {
      return this.productionInfo
    },
    getEdit () {
      // console.log(this.isEdit)
      return !this.isEdit
    }
  },
  created () {
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onOpened (e) {
      if (this.filteringKey !== null) {
        this.$refs.refCoilGrid.instance.filter([this.filteringKey, '=', this.filteringValue])
      }
    },
    onSelectionChanged (e) {
      this.currentValue = e.selectedRowsData[0]['품번']
      this.onValueChanged(e.selectedRowsData[0]['품번'])
      this.$emit('selected-pcode', e.selectedRowsData[0].품번)
      this.$refs.dropDownBoxRefName.instance.close()
    }
  }
}
</script>

<style lang="scss">

</style>
